<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script setup>
//import UserScalePage from "@/hooks/UserScalePage";
import {onMounted} from "vue";

// const monitor = require("@/common/js/monitor/monitor");
//let opstion = {
//  targetX: 1920,
//  targetY: 1080,
//  targetRatio: 16 / 9,
//};
//UserScalePage(opstion);

onMounted(() => {
  //autofit.init({
  //  el: "#app",
  //  dw: 1920,
  //  dh: 1080,
  //  resize: true,
  //  ignore:[
  //
  //  ]
  //}, false);
  //console.log('mounted 尺寸', window.innerWidth, window.innerHeight);
  //window.addEventListener('resize', () => {
  //  //console.log('resize 尺寸再变化', window.innerWidth, window.innerHeight);
  //});

  // 监测
  // monitor.init({
  //   baseUrl: "https://conviviality.omnimkt.com/monitor/moitor_api",
  //   unionid: "",
  //   openid: "",
  //   projectId: "9",
  //   projectName: "AFC",
  //   api_key: "22e5d83fd709093d4a8e3edd9842a1db551e3d9151cf01b0a3ec955e0f6d",
  //   currentPageUrl: window.location.href,
  //   ad_id: "",
  //   debug: true
  // });
})

</script>

<style lang="scss">
@import "common/scss/fonts.scss";

html,
body {
  width: 100%;
  height: 100%;
  margin: 0 auto 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  /* border: 5px solid red; */
}

#app {
  overflow: hidden;
  width: 100%;
  height: 100%;
}


img {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE/Edge */
  user-select: none; /* 标准语法 */
}

.opacity0 {
  opacity: 0 !important;
  pointer-events: none;
  height: 0 !important;
  transition: opacity 0.3s;
  overflow: hidden;
}

.opacity1 {
  pointer-events: all;
  transition: opacity .3s;
  opacity: 1 !important;
  z-index: 9999;
}



</style>
